import { useState } from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import { FeedbackDialog } from "../components/FeedbackDialog";
import { useAuthStore } from "../stores/authStore";
import { usePageMeta } from "../lib/usePageMeta";

/** Статическая страница о проекте и поддержке. Платёжной интеграции нет — только внешние ссылки. */
export function AboutPage() {
  const { t } = useTranslation();
  usePageMeta({ title: t("about.title"), description: t("seo.about") });
  const [reporting, setReporting] = useState(false);
  const authenticated = useAuthStore((state) => state.status) === "authenticated";
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      {reporting && <FeedbackDialog onClose={() => setReporting(false)} />}

      <div className="panel p-7">
        <h1 className="font-sans text-4xl text-ink-50">{t("about.title")}</h1>

        <div className="mt-4 space-y-4 text-sm leading-relaxed text-ink-300">
          <p>
            {t("about.what")}
          </p>
          <p>
            {/* Ссылка на форму, а не почтовый адрес: сообщение попадает
                модератору вместе с автором и датой, и на него можно
                ответить, не заводя переписку в почте. */}
            <Trans
              i18nKey="about.licensing"
              components={{
                feedback: authenticated ? (
                  <button
                    type="button"
                    className="text-amber-300 underline underline-offset-2 hover:text-amber-200"
                    onClick={() => setReporting(true)}
                  />
                ) : (
                  // Форма требует входа: сообщение без автора некому
                  // адресовать и не на что отвечать.
                  <Link to="/login" className="text-amber-300 underline underline-offset-2" />
                ),
              }}
            />
          </p>
        </div>
      </div>

      <div className="panel p-7">
        <h2 className="font-sans text-2xl text-ink-50">{t("about.supportTitle")}</h2>
        <p className="mt-2 text-sm text-ink-400">
          {t("about.supportText")}
        </p>

        <div className="mt-4 flex flex-wrap gap-2">
          <DonateLink href="https://boosty.to/vrk2803" label="Boosty" />
          <DonateLink href="https://ko-fi.com/vrk2803" label="Ko-fi" />
        </div>
      </div>

      <div className="panel p-7">
        <h2 className="font-sans text-2xl text-ink-50">{t("about.scoringTitle")}</h2>
        <ul className="mt-3 space-y-2 text-sm text-ink-300">
          <li>
            <Trans i18nKey="about.scoringPlace" components={{ b: <span className="text-ink-100" /> }} />
          </li>
          <li>
            <Trans i18nKey="about.scoringYear" components={{ b: <span className="text-ink-100" /> }} />
          </li>
          <li>
            <Trans i18nKey="about.scoringQuest" components={{ b: <span className="text-ink-100" /> }} />
          </li>
        </ul>
      </div>
    </div>
  );
}

function DonateLink({ href, label }: { href: string; label: string }) {
  return (
    <a href={href} target="_blank" rel="noreferrer noopener" className="btn-secondary">
      {label}
    </a>
  );
}
